import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from './Skeleton'

function NewsListItemTextSkeleton({
  featured,
}) {
  if (featured) {
    return (
      <Skeleton className="h-full w-full aspect-video space-y-10 rounded-lg" />
    )
  }
  return (
    <div className="h-[100px] w-full flex">
      <Skeleton className="block h-[100px] w-[100px] rounded-lg" />
      <div className="pt-2 pl-4 flex flex-col items-start">
        <Skeleton className="h-6 w-40 rounded" />
        <Skeleton className="mt-3 h-8 w-72 rounded" />
        <Skeleton className="mt-2 h-4 w-24 w-fullrounded" />
      </div>
    </div>
  )
}

NewsListItemTextSkeleton.propTypes = {
  featured: PropTypes.bool,
}

NewsListItemTextSkeleton.defaultProps = {
  featured: false,
}

export default NewsListItemTextSkeleton
